export default [

     {
          path: '/evidence',
          name: 'Evidence',
          component: () => import("@/views/Page/Errors/404.vue"),
           meta: {
               title: 'Evidence',
               
          },
     }
];